import React, { Component } from 'react'
import Select from 'react-select'
import querystring from 'querystring'

class ServicesContainer extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      filters: props.filters.map((f, i) => {
        return f.filters.values.map(v => {
          return {value:v, label: v, index: i}
        })
      }),
      filterLabels: props.filters.map(f => f.filters.label),
      filterValues: [],
      sortValues: [{label: 'A-Z', value: 'a-z'},
                   {label: 'Lowest price', value: 'lowest-price'},
                   {label: 'Highest price', value: 'highest-price'}],
      dropdownsHidden: props.mobile
    }
  }

  componentWillMount() {
    const filterParams = querystring.parse(this.props.filterParams);
    this.setState({
      filterValues: this.state.filters.map((f, i) => {
        const filterValue = filterParams[this.state.filterLabels[i]];
        if (filterValue && !!f.filter(e => e.value === filterValue).length) {
          this.props.handleChange({value: filterValue, index: i});
          return filterValue;
        }
        return f[0];
      })
    })
  }

  updateFilterValue(e) {
    let values = this.state.filterValues
    values[e.index] = e

    this.setState({
      filterValues: values
    })
    this.props.handleChange(e)
  }

  updateSortValue(e) {
    this.props.updateSortValue(e)
  }

  parseQuery(queryString) {
    var query = {};
    var pairs = (queryString[0] === '?' ? queryString.substr(1) : queryString).split('&');
    for (var i = 0; i < pairs.length; i++) {
        var pair = pairs[i].split('=');
        query[decodeURIComponent(pair[0])] = decodeURIComponent(pair[1] || '');
    }
    return query;
  }

  filterDropdown(options, i) {
    const displayedValue = this.props.accessLevel === 'bronze' ? this.state.filterLabels[i] : this.state.filterValues[i]
    return (
      <div key={i} className={`services-select-container relative flex flex-column ${this.props.accessLevel === 'bronze' ? 'bronze o-80 pointer-disabled' : ''}`}>
        <span className={`pb1 dib ${this.props.accessLevel === 'bronze' ? 'invisible' : ''}`}>{this.state.filterLabels[i]}</span>
        <Select options={options}
          classNamePrefix="services-select"
          isClearable={false}
          isSearchable={false}
          onChange={this.updateFilterValue.bind(this)}
          value={displayedValue}
          placeholder={displayedValue} />
      </div>
    )
  }

  sortDropdown(options) {
    return (
      <div className={`services-select-container flex flex-column mla mt3-half sort-dropdown ${this.props.accessLevel === 'bronze' ? 'o-50 pointer-disabled' : ''}`}>
        <Select
          options={this.state.sortValues}
          classNamePrefix="services-select"
          isClearable={false}
          isSearchable={false}
          onChange={this.updateSortValue.bind(this)}
          value={this.props.selectedSortValue} />
      </div>
    )
  }

  selectedClass(layout) {
    return this.props.layout == layout ? 'selected' : ''
  }

  toggleDropdowns() {
    this.setState({
      dropdownsHidden: !this.state.dropdownsHidden
    })
  }

  render() {
    return (
      <nav className={`relative z-5 fw6 pv2-ns pt2 pb3 flex border-box w-100 fr bb bl b--black-20 pl3 filters ${this.state.dropdownsHidden ? 'dropdowns-hidden' : ''}`}>
        <div onClick={this.toggleDropdowns.bind(this)} className='sideBarToggle'>
          Filters
          <svg onClick={this.props.toggleSidebar} height="25" width="30" viewBox="0 0 20 20" aria-hidden="true" focusable="false" className="chevron chevron-active pointer">
            <path d="M4.516 7.548c0.436-0.446 1.043-0.481 1.576 0l3.908 3.747 3.908-3.747c0.533-0.481 1.141-0.446 1.574 0 0.436 0.445 0.408 1.197 0 1.615-0.406 0.418-4.695 4.502-4.695 4.502-0.217 0.223-0.502 0.335-0.787 0.335s-0.57-0.112-0.789-0.335c0 0-4.287-4.084-4.695-4.502s-0.436-1.17 0-1.615z"></path>
          </svg>
        </div>

        {this.state.filters.map((options, i) => {
          return this.filterDropdown(options, i)
        })}

        {this.sortDropdown()}

        <div className="flex mr2 ui-switch mta mba">
          <span className="flex mt3 pt1 mr2">View</span>
          <div className={`pointer mr2 mt2 b--light-grey ba border-box table ${this.selectedClass('table')}`} onClick={()=>{this.props.toggleLayout('table')}}></div>
          <div className={`pointer mt2 b--light-grey ba border-box tile ${this.selectedClass('tile')}`} onClick={()=>{this.props.toggleLayout('tile')}}></div>
        </div>

      </nav>
      )
  }

}

export default ServicesContainer
